import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/ImportModule/ImportModule.tsx");
